export const initialStorage = {
  applicantId: null,
  accountStatus: null,
  accountType: null,
  dicDraft: {},
  email_trade_confirmation_consent: false,
  ekyc_consent: false,
  toc_consent: false,
  applicantInfo: {},
  brokerData: null,
  activeIndex: 0,
  indexApplicant: 0,
  equixId: null,
  applicantOther: null,
  isSubApplicant: false,
  addressData: {},
  all_application_submitted: false,
  isOperatorSupport: false,
  isSubmitted: false,
  files: {}
}

const dataStorage = {
  enviroment: 'PROD',
  userType: 0,
  addressKey: '',
  baseUrl: '',
  registerEmail: '',
  config: {},
  configAll: {},
  refreshToken: null,
  tokenRefresh: null,
  refreshTokenId: null,
  accessToken: null,
  deviceId: '',
  setError: null,
  theme: 'dark',
  listEnv: ['dev1', 'uat', 'equix', 'morrison', 'ricard', 'equitystorytrader', 'optixtrading', 'tradeforgood'],
  listDraft: [],
  ...initialStorage
}
export default dataStorage
